ControlBinders.register(`[data-alert]`, el => {
    let cookieValue = getCookie("alert-" + el.dataset.alertId);
    var bannerDismissedDate = new Date(cookieValue)

    let resizeTimeout;
    
    function onResize() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(calcHeight, 200); // Runs after resizing stops
    }
    
    if (bannerDismissedDate.getTime() < new Date(el.dataset.alertUpdated).getTime())
    {
        el.classList.remove(`alert--hidden`);
    }

    document.body.addEventListener("click", (event) => {
        if (!el.contains(event.target)) {
            el.removeAttribute("style");
            window.dispatchEvent(new Event('resize'));
        }
    });

    el.querySelector(`[data-close]`).addEventListener(`click`, () => {
        setCookie("alert-" + el.dataset.alertId, new Date())
        el.classList.add(`alert--hidden`);
        setTimeout(() => calcHeight(), 25);
    });

    const calcHeight = () => document.querySelector(':root').style.setProperty('--alert-height', `${el.parentElement.clientHeight}px`);

    function setCookie(name,value,days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/ ;secure";
    }
    function getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    function eraseCookie(name) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;secure';
    }

    calcHeight();

    window.addEventListener("resize", onResize);


});